import {
    SET_VIEW, SET_SEARCHTYPE, SET_STATSNAME, SET_FILTERS, SET_TILE_PAGINATION, SET_GRID_PAGINATION, SET_LIST_PAGINATION, SET_LOADMAPVIEW, SET_MAPMETADATA, SET_LOADPFCHARTVIEW, SET_APPLYCLICK
} from './types';


const initialState = {
    selectedView: 'Hybrid View',
    searchType: 'D',
    statsName: '',
    filters: { dbMachineFilterId: 1, machineName: 'All products', model: '', serial: '', unitNumber: '', factoryCampaigns: '', factoryCampaignsText:'' },
    tilePagination: { currentPage: 1 },
    gridPagination: { pageSize: 100, skip: 0, take: 100 },
    listPagination: { currentPage: 1, pageSize: 100, totalCount: 0 },
    loadmapview: false,
    loadperfchartview: false,
    applyClick: false,
    mapMetaData: {
        maxLat: -9999, maxLng: -9999, minLat: 9999, minLng: 9999, mapZoom: 0, mapCenter: {}, isSyncMaptoList: true
},
};

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_VIEW: {
            return {
                ...state,...action.selectedView
            };
        }
        case SET_SEARCHTYPE: {
            return {
                ...state,...action.searchType
            };
        }
        case SET_STATSNAME: {
            return {
                ...state,...action.statsName
            };
        }
        case SET_FILTERS: {
            return {
                ...state,...action.filters
            };
        }
        case SET_TILE_PAGINATION: {
            return {
                ...state, ...action.tilePagination
            };
        }
        case SET_GRID_PAGINATION: {
            return {
                ...state, ...action.gridPagination
            };
        }
        case SET_LIST_PAGINATION: {
            return {
                ...state, ...action.listPagination
            };
        }
        case SET_LOADMAPVIEW: {
            return {
                ...state, ...action.loadmapview
            };
        }
        case SET_MAPMETADATA: {
            return {
                ...state, ...action.mapMetaData
            };
        }
        case SET_LOADPFCHARTVIEW: {
            return {
                ...state, ...action.loadperfchartview
            };
        }
        case SET_APPLYCLICK: {
            return {
                ...state, ...action.applyClick
            };
        }
        default:
            return state;
    }
};

export default reducers;
